module.exports = __webpack_public_path__ + "img/full1-min.0c393c77.png";